import React, { PropsWithChildren, CSSProperties } from 'react';
import tw from 'tailwind-styled-components';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  style?: CSSProperties;
  className?: string;
  icon?: string;
}

interface AnchorProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  style?: CSSProperties;
  className?: string;
  icon?: string;
}

type Props = ButtonProps | AnchorProps;

const IconContainer = tw.div`
  absolute
  inset-y-0
  left-3
  flex
  items-center
  tex
`;

export const Button: React.FC<PropsWithChildren<Props>> = ({ children, ...props }) => {
  const { icon, style, className, ...rest } = props;

  if ('href' in props) {
    const { href, ...anchorProps } = rest as AnchorProps;
    return (
      <a href={href} style={style} className={`${className}`} {...anchorProps}>
        {icon && <IconContainer><i className={'mdi' + icon} /></IconContainer>}
        {children}
      </a>
    );
  }

  const { type, ...buttonProps } = rest as ButtonProps;
  return (
    <button type={type} style={style} className={` ${icon ? 'relative' : ''} ${className}`} {...buttonProps}>
      {icon && <IconContainer><i className={'mdi icons-edit ' + icon} /></IconContainer>}
      {children}
    </button>
  );
};